import * as React from 'react';
import {FunctionComponent, useState,useEffect} from 'react';
import {Grid, Typography,FormControl,NativeSelect,InputBase, Select, MenuItem, ListItemText} from "@material-ui/core"
import {Theme,withStyles,createStyles,makeStyles} from '@material-ui/core/styles';
import { TestDashboard } from './test-dashboard/testDashboard';
import { ParameterConfig } from './parameter-configuration/parameterConfig';
import { DeviceConfig } from './device-configuration/deviceConfig';
import { getAllBatches, getAllDevices, getAllMainTestCases, getDeviceTestSummery, getTestCondition } from './api-helper/apiHelper';

const useStyles = makeStyles((theme:Theme) => ({
    navButtons:{
        height:"55px",
        paddingTop:"20px",
        fontSize:"14px",
        cursor:"pointer"
    },
    text:{
        fontSize:"14px",
        color:"#5E5873",
        marginBottom:"10px"
    },
    dropdown:{
        width:"100%",
        height:"40px",
        backgroundColor:"#F4F5F7",
      },
  }));

export const TestingAutomationComponent:FunctionComponent=()=>{
    const classes=useStyles()
    const [step,setStep]=useState('test')
    const [deivces,setDevices]=useState([])
    const [batches,setBatches]=useState(["No Batches Found"])
    const [mainTestCases,setMainTestCases]=useState([])
    const [allMainTestData,setAllMainTestData]=useState([])
    const [allSubTestCases,setAllSubTestCases]=useState([])
    const [testSummary,setTestSummary] = useState()
    const [allTestConditions,setAllTestConditions]=useState([])

    const [selectedBatch,setSelectedBatch]=useState("Select The Batch")
    const [selectedMainTestCase,setSelectedMainTestCase] = useState("Select The Test Case")
    const [selectedDevice,setSelectedDevice]=useState([])
    const [selectedSubTestCase,setSelectedSubTestCase]=useState()
    const [selectedTestCondition,setSelectedTestCondition]=useState([])

    const cancel=()=>{
        setSelectedDevice([])
        setSelectedTestCondition([])
    }
    const selectBatch = async(e)=>{
        e.persist();
        setSelectedBatch(e.target.value)
        setMainTestCases([])
        setAllMainTestData([])
        setAllSubTestCases([])
        const mainTestCasesData= await getAllMainTestCases(e.target.value)
        const testSummery = await getDeviceTestSummery(e.target.value)
        if(mainTestCasesData!==undefined){
            setSelectedMainTestCase(mainTestCasesData.data[0].id)
            setMainTestCases(mainTestCasesData.mainTestCases)
            setAllMainTestData(mainTestCasesData.data)
            setAllSubTestCases(mainTestCasesData.data[0].subTestCases)
            setSelectedSubTestCase(mainTestCasesData.data[0].subTestCases[0].id)
        }
        if(testSummery!==undefined){
            setTestSummary(testSummery)
        }
    }
    const selectMainTestCase=(e)=>{
        setSelectedMainTestCase(e.target.value)
        const index= allMainTestData.findIndex(obj=>obj.id===e.target.value)
        setAllSubTestCases(allMainTestData[index].subTestCases)
        setSelectedSubTestCase(allMainTestData[index].subTestCases[0].id)
    }
    const selectDevice=(e)=>{
        setSelectedDevice(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value,)
    }
    const selectSubTestCase=(e)=>{
        setSelectedSubTestCase(e.target.value)
    }
    const selectTestCondition=(e)=>{
        setSelectedTestCondition(e.target.value)
    }

    useEffect(()=>{
       const allBatches = async()=>{
            const allbatches = await getAllBatches()
            if(allbatches!==undefined){
                setBatches(allbatches)
                setSelectedBatch(allbatches[0])
                const mainTestCasesData = await getAllMainTestCases(allbatches[0])
                if(mainTestCasesData!==undefined){
                    setMainTestCases(mainTestCasesData.mainTestCases)
                    setAllMainTestData(mainTestCasesData.data)
                    setSelectedMainTestCase(mainTestCasesData.data[0].id)
                    setAllSubTestCases(mainTestCasesData.data[0].subTestCases)
                    setSelectedSubTestCase(mainTestCasesData.data[0].subTestCases[0].id)
                }
                const testSummery = await getDeviceTestSummery(allbatches[0])
                if(testSummery!==undefined){
                    setTestSummary(testSummery)
                }
            }
       }
       const allDevices=async()=>{
            const devices = await getAllDevices()
            if(deivces!==undefined){
                setDevices(devices)
            }
       }
       const allTest=async()=>{
        const allTestCondition = await getTestCondition()
        if(allTestCondition!==undefined){
            setAllTestConditions(allTestCondition)
        }
       }

       allBatches()
       allDevices()
       allTest()
    },[])
    return(
        <div className={`testing`}>
            <Grid container>
                <Grid item xs={4} md={4} 
                    onClick={()=>setStep('test')} 
                    className={classes.navButtons} 
                    style={{backgroundColor:step==="test"?"#CACFD7":"#ECEDEF"}}
                >Test Dashboard
                </Grid>
                <Grid item xs={4} md={4} 
                    onClick={()=>setStep('parameter')} 
                    className={classes.navButtons} 
                    style={{backgroundColor:step==="parameter"?"#CACFD7":"#ECEDEF"}}
                >Parameter Configuration
                </Grid>
                <Grid item xs={4} md={4} 
                    onClick={()=>setStep('device')} 
                    className={classes.navButtons} 
                    style={{backgroundColor:step==="device"?"#CACFD7":"#ECEDEF"}}
                >Device Configuration
                </Grid>

                <Grid item xs={12} md={3} style={{textAlign:"left", margin:'20px'}}>
                    <Typography className={classes.text}>Select the batch</Typography>
                    <FormControl className={classes.dropdown}>
                        <NativeSelect
                            id="demo-customized-select-native"
                            value={selectedBatch}
                            className={classes.dropdown}
                            onChange={selectBatch}
                            input={<BootstrapInput/>}
                        >
                        {
                            batches.map((batch,index)=>{
                                return(<option key={index} value={batch}>{batch}</option>)
                            })
                        }
                        </NativeSelect>
                    </FormControl>
                </Grid>
                {
                    step==="test" || step==="parameter"?
                        <Grid item xs={12} md={3} style={{textAlign:"left", margin:'20px'}}>
                            <Typography className={classes.text}>Select Test Cases</Typography>
                            <FormControl className={classes.dropdown}>
                                <NativeSelect
                                    id="demo-customized-select-native"
                                    value={selectedMainTestCase}
                                    className={classes.dropdown}
                                    onChange={selectMainTestCase}
                                    input={<BootstrapInput/>}
                                >
                                {
                                    allMainTestData.map((mainCase,index)=>{
                                        return (<option key={index} value={mainCase.id}>{mainCase.mainTestTitle}</option>)
                                    })
                                }
                                </NativeSelect>
                            </FormControl>
                        </Grid>
                    :
                        <>
                            <Grid item xs={12} md={3} style={{textAlign:"left", margin:'20px'}}>
                                <Typography className={classes.text}>Current device configuration</Typography>
                                <FormControl className={classes.dropdown}>
                                    <Select
                                        id="demo-customized-select-native"
                                        value={selectedDevice}
                                        className={classes.dropdown}
                                        onChange={selectDevice}
                                        multiple
                                        renderValue={(selected:string[]) => selected.join(', ')}
                                        input={<BootstrapInput/>}
                                    >
                                        {
                                            deivces!==undefined && deivces.map((device,index)=>{
                                                return(<MenuItem key={index} value={device.id}>
                                                    <ListItemText primary={device.name}/>
                                                </MenuItem>)
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}></Grid>
                            <Grid item xs={12} md={3} style={{textAlign:"left", margin:'20px'}}>
                                <Typography className={classes.text}>Configure The Main Test Case</Typography>
                                <FormControl className={classes.dropdown}>
                                    <NativeSelect
                                        id="demo-customized-select-native"
                                        value={selectedMainTestCase}
                                        className={classes.dropdown}
                                        onChange={selectMainTestCase}
                                        input={<BootstrapInput/>}
                                    >
                                    {
                                        allMainTestData.map((mainCase,index)=>{
                                            return (<option key={index} value={mainCase.id}>{mainCase.mainTestTitle}</option>)
                                        })
                                    }
                                    </NativeSelect>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3} style={{textAlign:"left", margin:'20px'}}>
                                <Typography className={classes.text}>Configure a Sub Test Case</Typography>
                                <FormControl className={classes.dropdown}>
                                    <NativeSelect
                                        id="demo-customized-select-native"
                                        value={selectedSubTestCase}
                                        className={classes.dropdown}
                                        onChange={selectSubTestCase}
                                        input={<BootstrapInput/>}
                                    >
                                    {
                                        allSubTestCases.map((sub,index)=>{
                                            return(<option key={index} value={sub.id}>{sub.subTestTitle}</option>)
                                        })
                                    }
                                    </NativeSelect>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3} style={{textAlign:"left", margin:'20px'}}>
                                <Typography className={classes.text}>Configure a Test Condition</Typography>
                                <FormControl className={classes.dropdown}>
                                    <Select
                                        id="demo-customized-select-native"
                                        value={selectedTestCondition}
                                        className={classes.dropdown}
                                        onChange={selectTestCondition}
                                        multiple
                                        renderValue={(selected:string[]) => selected.join(', ')}
                                        input={<BootstrapInput/>}
                                    >
                                        {
                                            allTestConditions!==undefined && allTestConditions.map((test,index)=>{
                                                return(<MenuItem key={index} value={test}>
                                                    <ListItemText primary={test}/>
                                                </MenuItem>)
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                        </>
                }
                <Grid item md={7}></Grid>

                <Grid item xs={12} md={12}>
                    {
                        step==="test"?
                            <div>
                                {
                                    allMainTestData.length>0?
                                        <TestDashboard mainTestCase={selectedMainTestCase} allMainTestCases={mainTestCases} allData={allMainTestData} testSummaryData={testSummary}/>
                                    :<></>
                                }
                            </div>
                        :
                        step==="parameter"?
                            <div>
                                <ParameterConfig batch={selectedBatch} mainTestId={selectedMainTestCase} allData={allMainTestData}/>
                            </div>
                        :
                            <div style={{margin:"20px"}}>
                                {
                                    allMainTestData.length>0?
                                        <DeviceConfig onClick={()=>cancel()} testCondition={selectedTestCondition} batch={selectedBatch} devicesData={selectedDevice} mainTestCase={selectedMainTestCase} subTestCase={selectedSubTestCase} allData={allMainTestData}/>
                                    :<></>
                                }
                            </div>
                    }
                </Grid>
            </Grid>
        </div>
    )
} 

//Bootstrap like dropdown component
const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: "#F4F5F7",
      border: '1px solid #ced4da',
      fontSize: 16,
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }),
)(InputBase);